import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FolderPlus, Check, Plus } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function CollectionPicker({ titleId }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [cols, setCols] = useState([]);
  const [name, setName] = useState("");
  useEffect(() => { if (open && user) api.get("/me/collections").then((r) => setCols(r.data.items)); }, [open, user]);
  if (!user) return null;
  const toggle = async (c) => {
    try {
      const { data } = await api.post(`/me/collections/${c.id}/titles/${titleId}`);
      setCols((cs) => cs.map((x) => (x.id === c.id ? { ...x, title_ids: data.added ? [...x.title_ids, titleId] : x.title_ids.filter((i) => i !== titleId) } : x)));
      toast.success(data.added ? `Added to ${c.name}` : `Removed from ${c.name}`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  const create = async (e) => {
    e.preventDefault();
    try { const { data } = await api.post("/me/collections", { name, description: "", public: true }); setName(""); await toggle(data); setCols((c) => [{ ...data, title_ids: [titleId] }, ...c]); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid="add-to-collection-btn" className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2.5 text-sm hover:border-purple-400"><FolderPlus className="h-4 w-4" />Collection</button>
      </PopoverTrigger>
      <PopoverContent className="w-72 border-white/10 bg-[#12121A]">
        <p className="mb-2 text-xs font-bold uppercase tracking-wider text-slate-400">Add to collection</p>
        <div className="max-h-56 space-y-1 overflow-y-auto">
          {cols.map((c) => (
            <button key={c.id} onClick={() => toggle(c)} data-testid={`collection-option-${c.id}`} className="flex w-full items-center justify-between rounded-lg px-2 py-2 text-left text-sm hover:bg-white/5">
              {c.name}{c.title_ids.includes(titleId) && <Check className="h-4 w-4 text-amber-400" />}
            </button>
          ))}
          {!cols.length && <p className="text-xs text-slate-500">No collections yet.</p>}
        </div>
        <form onSubmit={create} className="mt-3 flex gap-2">
          <input data-testid="new-collection-name" required minLength={2} value={name} onChange={(e) => setName(e.target.value)} placeholder="New collection" className="flex-1 rounded-lg border border-white/10 bg-black/30 px-3 py-1.5 text-sm outline-none" />
          <button data-testid="new-collection-create" className="rounded-lg bg-purple-600 p-2"><Plus className="h-4 w-4" /></button>
        </form>
      </PopoverContent>
    </Popover>
  );
}
